/* TWS "A home for writers" — the scroll-pinned accordion.
   Ported from the local index.html IIFE, scoped per section instance so more
   than one could coexist. While pinned, scroll progress drives which panel is
   open and the brass rail's fill; unpinned (mobile) it opens the panel nearest
   viewport centre. Clicking a panel holds it until the reader scrolls ~40px.

   The design's magic numbers (open starts at 10%, last panel + full rail at 88%)
   were tuned for FOUR panels, where the per-panel step is 0.26 = 0.78 / 3. Here
   the step is derived as 0.78 / (n - 1) so it stays exact at n = 4 and still
   maps sensibly for any panel count the merchant sets. */
(function () {
  function init(sec) {
    if (sec.__twsCm) return;
    sec.__twsCm = true;

    var items  = Array.prototype.slice.call(sec.querySelectorAll('.cm-item'));
    var fill   = sec.querySelector('.cm-fill');
    var numBig = sec.querySelector('.cm-num-big');
    if (!items.length) return;

    var n    = items.length;
    var OPEN = 0.1;                              /* progress at which panel 0 opens */
    var SPAN = 0.78;                             /* fill completes / last panel opens here (0.1 + 0.78) */
    var step = n > 1 ? SPAN / (n - 1) : SPAN;    /* 0.26 at n = 4, exactly the design */

    var idx = -1;        /* open panel (-1 = all closed) */
    var manualY = null;  /* scrollY when the user last clicked a panel */

    function held() { return manualY !== null && Math.abs(window.scrollY - manualY) < 40; }

    function paint(next) {
      if (next === idx) return;
      idx = next;
      for (var i = 0; i < items.length; i++) {
        items[i].setAttribute('data-open', i === idx ? '1' : '0');
      }
      if (numBig) numBig.textContent = idx < 0 ? '00' : '0' + (idx + 1);
    }

    function isPinned() {
      var st = sec.firstElementChild;
      return !!st && getComputedStyle(st).position === 'sticky';
    }

    function progress() {
      var r = sec.getBoundingClientRect();
      return Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - window.innerHeight)));
    }

    function apply() {
      if (manualY !== null && !held()) manualY = null;

      var next;
      if (isPinned()) {
        var p = progress();
        if (fill) fill.style.height = Math.min(100, Math.max(0, ((p - OPEN) / SPAN) * 100)).toFixed(1) + '%';
        next = p < OPEN ? -1 : Math.max(0, Math.min(n - 1, Math.floor((p - OPEN) / step)));
      } else {
        /* unpinned (mobile): open whichever panel sits nearest 42% viewport height */
        var mid = window.innerHeight * 0.42, best = Infinity;
        next = 0;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].getBoundingClientRect().top + 30 - mid);
          if (d < best) { best = d; next = i; }
        }
      }
      if (next != null && !held()) paint(next);
    }

    items.forEach(function (it, i) {
      it.addEventListener('click', function () {
        manualY = window.scrollY;
        paint(idx === i ? -1 : i);
      });
    });

    var queued = false;
    function run() { queued = false; try { apply(); } catch (e) {} }
    /* rAF alone is throttled while the tab/pane is hidden, so keep the design's
       belt-and-braces scheduling: a 40ms timeout plus the frame, and a slow
       interval so the panels are always in sync with the scroll position. */
    function onScroll() { if (queued) return; queued = true; requestAnimationFrame(run); setTimeout(run, 40); }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setInterval(run, 250);
    run();
  }

  function boot() {
    var els = document.querySelectorAll('[data-community]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-community]');
    if (el) init(el);
  });
})();
